const TAX_STATUS_IDLE = {
  isChecking: false,
  status: "",
  error: "",
  // The ATL row found for the number (ATL check only).
  taxpayer: null,
};

const initialState = {
  // Live tax status on the Add Buyer form, one entry per status box.
  buyerTaxStatus: { salesTax: TAX_STATUS_IDLE, atl: TAX_STATUS_IDLE },

  // The buyer whose saved tax status is being re-checked right now, or "".
  refreshingBuyerStatusId: "",

  // Getting Buyer List
  isGettingBuyer: false,
  buyerList: [],

  // is Adding Buyer
  isAddingBuyer: false,

  // is Updating Buyer
  isUpdatingBuyer: false,

  // is Deleting Buyer
  isDeletingBuyer: false,

  // Is Getting Buyer Details
  isGettingBuyerDetails: false,
  buyerDetailsList: {},

  // Buyer Ledger
  isGettingBuyerLedger: false,
  buyerLedgerInvoices: [],
  buyerLedgerBuyer: null,
  buyerLedgerError: "",
  isExportingBuyerLedger: false,
};

const BuyerReducer = (state = initialState, action) => {
  switch (action.type) {
    // Live tax status on the Add Buyer form
    case "BUYER_TAX_STATUS_REQUEST":
      return {
        ...state,
        buyerTaxStatus: {
          ...state.buyerTaxStatus,
          [action.payload.check]: { ...TAX_STATUS_IDLE, isChecking: true },
        },
      };
    case "BUYER_TAX_STATUS_SUCCESS":
      return {
        ...state,
        buyerTaxStatus: {
          ...state.buyerTaxStatus,
          [action.payload.check]: {
            ...TAX_STATUS_IDLE,
            status: action.payload.status,
            taxpayer: action.payload.taxpayer ?? null,
          },
        },
      };
    case "BUYER_TAX_STATUS_ERROR":
      return {
        ...state,
        buyerTaxStatus: {
          ...state.buyerTaxStatus,
          [action.payload.check]: {
            ...TAX_STATUS_IDLE,
            error: action.payload.message,
          },
        },
      };
    case "BUYER_TAX_STATUS_CLEAR":
      return { ...state, buyerTaxStatus: initialState.buyerTaxStatus };
    // Refreshing one buyer's saved tax status
    case "REFRESH_BUYER_STATUS_REQUEST":
      return { ...state, refreshingBuyerStatusId: action.payload };
    case "REFRESH_BUYER_STATUS_SUCCESS":
    case "REFRESH_BUYER_STATUS_ERROR":
      return { ...state, refreshingBuyerStatusId: "" };
    // Getting Buyer List
    case "BUYER_LIST_REQUEST":
      return {
        ...state,
        isGettingBuyer: true,
      };
    case "BUYER_LIST_SUCCESS":
      return {
        ...state,
        buyerList: action.payload?.data,
        page: action.payload?.page,
        totalResults: action.payload?.totalResults,
        isGettingBuyer: false,
      };
    case "BUYER_LIST_ERROR":
      return {
        ...state,
        isGettingBuyer: false,
      };
    // Editing Buyer List
    case "ADD_BUYER_REQUEST":
      return {
        ...state,
        isAddingBuyer: true,
      };
    case "ADD_BUYER_SUCCESS":
      return {
        ...state,
        isAddingBuyer: false,
      };
    case "ADD_BUYER_ERROR":
      return {
        ...state,
        isAddingBuyer: false,
      };
    // Updateing Buyer List
    case "UPDATE_BUYER_LIST_REQUEST":
      return {
        ...state,
        isUpdatingBuyer: true,
      };
    case "UPDATE_BUYER_LIST_SUCCESS":
      return {
        ...state,
        isUpdatingBuyer: false,
      };
    case "UPDATE_BUYER_LIST_ERROR":
      return {
        ...state,
        isUpdatingBuyer: false,
      };
    // Deleting Buyer List
    case "DELETE_BUYER_LIST_REQUEST":
      return {
        ...state,
        isDeletingBuyer: true,
      };
    case "DELETE_BUYER_LIST_SUCCESS":
      return {
        ...state,
        isDeletingBuyer: false,
      };
    case "DELETE_BUYER_LIST_ERROR":
      return {
        ...state,
        isDeletingBuyer: false,
      };
    // IS Getting BuyerDetails
    case "GET_BUYER_DETAILS_REQUEST":
      return {
        ...state,
        isGettingBuyerDetails: true,
      };
    case "GET_BUYER_DETAILS_SUCCESS":
      return {
        ...state,
        isGettingBuyerDetails: false,
        buyerDetailsList: action.payload?.data,
      };
    case "GET_BUYER_DETAILS_ERROR":
      return {
        ...state,
        isGettingBuyerDetails: false,
      };
    // Buyer Ledger
    case "BUYER_LEDGER_REQUEST":
      return {
        ...state,
        isGettingBuyerLedger: true,
        buyerLedgerError: "",
      };
    case "BUYER_LEDGER_SUCCESS":
      return {
        ...state,
        isGettingBuyerLedger: false,
        buyerLedgerInvoices: action.payload?.data || [],
        buyerLedgerBuyer: action.payload?.buyer || null,
      };
    case "BUYER_LEDGER_ERROR":
      return {
        ...state,
        isGettingBuyerLedger: false,
        buyerLedgerInvoices: [],
        buyerLedgerBuyer: null,
        buyerLedgerError: action.payload,
      };
    case "BUYER_LEDGER_CLEAR":
      return {
        ...state,
        isGettingBuyerLedger: false,
        buyerLedgerInvoices: [],
        buyerLedgerBuyer: null,
        buyerLedgerError: "",
      };
    case "EXPORT_BUYER_LEDGER_REQUEST":
      return { ...state, isExportingBuyerLedger: true };
    case "EXPORT_BUYER_LEDGER_DONE":
      return { ...state, isExportingBuyerLedger: false };
    default:
      return state;
  }
};

export default BuyerReducer;
